import styled, { css } from 'styled-components';

import { media } from 'utils/detection';
import P from 'components/P';

export default styled(P)`
  color: ${props => props.theme.textSemiDark};
  margin: 48px 0 0 0;

  ${props => props.smallMargin && css`
    margin: 20px 0 0 0;

    ${media.medium`
      margin: 3.5vw 0 0 0;
    `}
  `}
`;
